import { Control, FieldErrors, FieldValues, UseFormWatch } from 'react-hook-form';

import { User } from 'types/api/users.type';

import { CheckboxWithControl } from 'components/CheckboxWithControl';

import * as S from './EditForm.styles';
import { FormItem, PermissionsRow } from './types';

type EditFormProps = {
  data: PermissionsRow[];
  onSubmit: () => void;
  control: Control;
  isDirty?: boolean;
  isButtonsDisabled?: boolean;
  errors?: FieldErrors;
  hideUndo?: boolean;
  reset?: (values: {}) => void;
  isPermissions?: boolean;
  initialValues?: User;
  submitBtnLabel?: string;
  children?: React.ReactNode;
  onPermissionsChange?: (arg: React.ChangeEvent<HTMLInputElement>, name?: string) => void;
  watch?: UseFormWatch<FieldValues>;
  hasButtons?: boolean;
};

export function EditForm(props: EditFormProps): React.ReactElement {
  const {
    data,
    onSubmit,
    control,
    reset = () => {},
    onPermissionsChange = undefined,
    watch = undefined,
  } = props;

  const renderColumn = (item: FormItem[]) =>
    item.map((c, i) => (
      <CheckboxWithControl
        key={c.name}
        name={c.name}
        label={c.label || ''}
        control={control}
        defaultChecked={c.defaultChecked}
        isCheckIcon={c.isCheckIcon}
        margin={c?.margin}
        disabled={c?.disabled}
        reset={reset}
        watch={watch}
        onCheck={
          onPermissionsChange
            ? (e, name) => {
                onPermissionsChange(e, name);
              }
            : () => {
                if (c.onChange) c.onChange();
              }
        }
      />
    ));

  return (
    <form onSubmit={onSubmit}>
      <S.ContentContainer>
        {data.map((row) => (
          <S.RowContainer key={row.row} divider={row.divider}>
            {row.colItems.map((item) => (
              <S.ColumnContainer key={null}>{renderColumn(item)}</S.ColumnContainer>
            ))}
          </S.RowContainer>
        ))}
      </S.ContentContainer>
    </form>
  );
}
